<template>
  <div class="dormitoryMaintenance">
    <img alt="" src="@/assets/image/报修.png" style="width: 100%;"/>
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="80px" class="form">
      <el-form-item label="工号" prop="userName">
        <el-input size="small" v-model="ruleForm.userName" clearable placeholder="请输入工号" @change="showDetails"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="nickName">
        <el-input size="small" v-model="ruleForm.nickName" disabled ></el-input>
      </el-form-item>
      <el-form-item label="部门" prop="dept">
        <el-input size="small" v-model="ruleForm.dept" disabled ></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="contact" required>
        <el-input size="small" v-model="ruleForm.contact" clearable placeholder="请输入手机号"></el-input>
      </el-form-item>
      <!-- <el-form-item label="申请时间" prop="applyTime">
        <el-col :span="24">
          <el-date-picker type="date" size="small" clearable placeholder="选择申请时间" v-model="ruleForm.applyTime"
            style="width: 100%;"></el-date-picker>
        </el-col>
      </el-form-item> -->
      <el-form-item label="需求时间" prop="requireTime">
        <el-col :span="24">
          <el-date-picker type="datetime" size="small" clearable placeholder="选择需求时间" v-model="ruleForm.requireTime"
            style="width: 100%;"></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="业务类别" prop="category">
        <el-radio-group size="small" v-model="ruleForm.category">
          <el-radio :label="1">行政报修</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="厂区" prop="area">
        <el-radio-group size="small" v-model="ruleForm.area" @change="areaChange">
          <el-radio :label="1">台虹</el-radio>
          <el-radio :label="2">古城</el-radio>
          <el-radio :label="3">邻里</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-show="ruleForm.area == 1" label="台虹区域" prop="groupTh">
        <el-radio-group size="small" v-model="ruleForm.thRepairArea">
          <el-radio label="1栋宿舍">1栋宿舍</el-radio>
          <el-radio label="2栋宿舍">2栋宿舍</el-radio>
          <el-radio label="3栋宿舍">3栋宿舍</el-radio>
          <el-radio label="4栋宿舍">4栋宿舍</el-radio>
          <el-radio label="5栋宿舍">5栋宿舍</el-radio>
          <el-radio label="1号楼公区">1号楼公区</el-radio>
          <el-radio label="2号楼公区">2号楼公区</el-radio>
          <el-radio label="3号楼公区">3号楼公区</el-radio>
          <el-radio label="厂区外围">厂区外围</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-show="ruleForm.area == 2" label="古城区域" prop="groupGC">
        <el-radio-group size="small" v-model="ruleForm.gcRepairArea">
          <el-radio label="研发大楼">研发大楼</el-radio>
          <el-radio label="1栋宿舍">1栋宿舍</el-radio>
          <el-radio label="2栋宿舍">2栋宿舍</el-radio>
          <el-radio label="3栋宿舍">3栋宿舍</el-radio>
          <el-radio label="车间公共区">车间公共区</el-radio>
          <el-radio label="厂区外围">厂区外围</el-radio>
          <el-radio label="地下车库">地下车库</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="维修类别" prop="repairType">
        <el-radio-group size="small" v-model="ruleForm.repairType">
          <el-radio label="水管类">水管类</el-radio>
          <el-radio label="电器类">电器类</el-radio>
          <el-radio label="门锁类">门锁类</el-radio>
          <el-radio label="床柜类">床柜类</el-radio>
          <el-radio label="消防类">消防类</el-radio>
          <el-radio label="墙砖类">墙砖类</el-radio>
          <el-radio label="1">其他</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="ruleForm.repairType == 1" label="其他描述" prop="repairTypeDetails">
        <el-input size="small" clearable type="textarea" v-model="ruleForm.repairTypeDetails" placeholder="请输入维修类别其他项描述"></el-input>
      </el-form-item>
      <el-form-item label="具体位置" prop="address">
        <el-input size="small" clearable v-model="ruleForm.address" placeholder="请输入具体位置(XX号宿舍)"></el-input>
      </el-form-item>
      <el-form-item label="申请内容" prop="content">
        <el-input size="small" clearable type="textarea" v-model="ruleForm.content" placeholder="请输入申请内容"></el-input>
      </el-form-item>
      <el-form-item label="图片上传">
        <el-upload
          class="upload-demo"
          ref="upload"
          :action="fileAction"
          :limit="limitNum"
          :before-upload="beforeUploadFile"
          :on-change="fileChange"
          :on-exceed="exceedFile"
          :on-success="handleSuccess"
          :on-error="handleError"
          :on-remove="handleRemove"
          :file-list="fileList"
          list-type="picture"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div class="el-upload__tip" slot="tip">图片大小不超过 <span style="color: red;">5M</span> ，支持jpg、jpeg、png格式</div>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="onSubmit('ruleForm')">提交</el-button>
        <el-button size="small" @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'dormitoryMaintenance',

  data() {
    //自定义规则
    // let validatePhone = (rule,value,callback)=>{
    //   if (!value){
    //       callback(new Error('手机号不能为空！'));
    //   }
    //   //正则表达式
    //   if (!/^1[3456789]\d{9}$/.test(value)){
    //       callback(new Error('手机号不正确！'));
    //   }
    // };
    return {
      ruleForm: {
        userName: '',
        nickName: '',
        dept: '',
        contact:'',
        // applyTime: '',
        requireTime: '',
        category: 1,
        area: 1,
        thRepairArea:'',
        gcRepairArea:'',
        repairType:'',
        repairTypeDetails:'',
        address: '',
        content: ''
      },
      rules: {
        userName: [
          { required: true, message: '请输入工号', trigger: 'blur' }
        ],
        nickName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        dept: [
          { required: true, message: '请输入部门', trigger: 'blur' }
        ],
        contact: [
          // { validator: validatePhone, trigger: 'blur'}
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        // applyTime: [
        //   { type: 'date', required: true, message: '请选择申请时间', trigger: 'change' }
        // ],
        requireTime: [
          { type: 'date', required: true, message: '请需求时间', trigger: 'change' }
        ],
        // type: [
        //   { type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change' }
        // ],
        category: [
          { required: true, message: '请选择业务类别', trigger: 'change' }
        ],
        area: [
          { required: true, message: '请选择厂区', trigger: 'change' }
        ],
        repairTypeDetails: [
          { required: true, message: '请输入维修类别其他项描述', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入具体位置', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入申请内容', trigger: 'blur' }
        ]
      },
      fileAction: this.axios.defaults.baseURL + "/apis/common/upload",
      attachment: "",
      attUrl: "",
      limitNum: 1,
      fileList: [],
      flag: false
    };
  },
  created() {
    document.title = '宿舍报修';
  },
  mounted() {

  },

  methods: {
    exceedFile(files, fileList) {
      this.$message.warning("只能选择 " + this.limitNum + " 个文件");
    },
    fileChange(file, fileList) {
      this.fileList = fileList;
    },
    beforeUploadFile(file) {
      const supportFileTypesList = ["jpg", "jpeg", "png"];
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isSupportFileType = supportFileTypesList.includes(extension);
      let size = file.size / 1024 / 1024;
      if (!isSupportFileType) {
        this.$message.warning("请上传jpg、jpeg、png格式的图片");
      }
      if (size > 5) {
        this.$message.warning("图片大小不得超过5M");
      }
      return isSupportFileType && size < 5;
    },
    handleSuccess(res, file, fileList) {
      this.fileList = fileList;
      this.attachment = res.fileName;
      this.attUrl = res.url;
      this.$message.success("图片上传成功");
    },
    handleError(err, file, fileList) {
      this.$message.error("图片上传失败");
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.attachment = "";
      this.attUrl = "";
    },
    areaChange(){
      this.ruleForm.gcRepairArea = ''
      this.ruleForm.thRepairArea = ''
      this.ruleForm.repairType = ''
      this.ruleForm.repairTypeDetails = ''
    },
    showDetails(){
      this.axios({
        url: "/platform?bh=" + this.ruleForm.userName,
        method: "get",
        headers: {
          'apikey': 'cHDBxH2SsOE8anIrKerhaNEfbqrzR0bu'
        }
      }).then((res) => {
        if (res.code == 200102) {
          let data = res.data[0];
          this.ruleForm.nickName = data.xm;
          this.ruleForm.dept = data.bm;
          this.flag = true;
        } else {
          this.ruleForm.nickName = '';
          this.ruleForm.dept = '';
          this.flag = false;
          this.$message.warning("查询姓名部门有误,请重新输入工号！");
        }
      }).catch(() => {
        this.$message.error("查询员工信息失败，请稍后重试");
      });
    },
    onSubmit(formName){
      if(!this.flag){
        this.$message.error("请输入正确的工号！");
        return false
      }
      if (!/^1[3456789]\d{9}$/.test(this.ruleForm.contact)){
        this.$message.error("手机号不正确，请重新填写！");
        return false
      }
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.handleSubmit();
        } else {
          console.log('error submit!!');
          return false
        }
      });
    },
    resetForm(formName){
      this.$refs[formName].resetFields();
      this.fileList = [];
      this.attachment = "";
      this.attUrl = "";
      this.$refs.upload && this.$refs.upload.clearFiles();
    },
    handleSubmit(){
      if(this.ruleForm.area == 1 && !this.ruleForm.thRepairArea){
        this.$message.error("请选择台虹区域！");
        return false
      }
      if(this.ruleForm.area == 2 && !this.ruleForm.gcRepairArea){
        this.$message.error("请选择古城区域！");
        return false
      }
      if(!this.ruleForm.repairType){
        this.$message.error("请选择维修类别！");
        return false
      }
      if(this.ruleForm.repairType == 1 && !this.ruleForm.repairTypeDetails){
        this.$message.error("请输入维修类别其他项描述！");
        return false
      }
      let params = {
        userName: this.ruleForm.userName,
        nickName: this.ruleForm.nickName,
        dept: this.ruleForm.dept,
        contact: this.ruleForm.contact,
        // applyTime: this.ruleForm.applyTime,
        requireTime: moment(this.ruleForm.requireTime).format("YYYY-MM-DD HH:mm:ss"),
        category: this.ruleForm.category,
        area: this.ruleForm.area,
        thRepairArea: this.ruleForm.thRepairArea,
        gcRepairArea: this.ruleForm.gcRepairArea,
        repairType: this.ruleForm.repairType,
        repairTypeDesc: this.ruleForm.repairTypeDetails,
        address: this.ruleForm.address,
        content: this.ruleForm.content,
        attachment: this.attachment,
        attUrl: this.attUrl
      }
      this.axios({
        url: "/apis/dorm/add",
        method: "post",
        data: params
      }).then((res) => {
        if (res.code == 200) {
          this.resetForm('ruleForm');
          this.$message.success("提交成功！");
        } else {
          this.$message.error("提交失败，请重试！");
        }
      }).catch(() => {
        this.$message.error("提交失败，请稍后重试");
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.dormitoryMaintenance {
  >img{
    vertical-align: top;
  }
  .form{
    padding: 30px;
  }
}
</style>
<style lang="scss">
.dormitoryMaintenance{
  .el-form-item__content{
    text-align: left !important;
  }
  .el-date-picker{
    left: 50% !important;
    transform: translateX(-50%) !important;
  }
  .el-radio{
    margin-right: 20px;
  }
  .el-radio__label{
    padding-left: 5px;
    vertical-align: middle;
    margin-bottom: 3px;
  }
  .upload-demo{
    text-align: left;
  }
  .el-upload__tip{
    margin-top: 0;
    line-height: 1.2;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/onlineApp/dormitoryMaintenance.vue